import { Enumify } from "enumify";

class AdCategory extends Enumify {
  static tv = new AdCategory({
    name: "TVCF",
  });
  static print = new AdCategory({
    name: "PRINT",
  });
  static radio = new AdCategory({
    name: "RADIO",
  });
  static outdoor = new AdCategory({
    name: "OOH",
  });
  static cinema = new AdCategory({
    name: "CINEMA",
  });
  static inet = new AdCategory({
    name: "ONLINE 동영상",
  });
  static internet = new AdCategory({
    name: "ONLINE 배너",
  });
  static inetb = new AdCategory({
    name: "확장형 배너",
  });
  static mobile = new AdCategory({
    name: "모바일",
  });
  static newtype = new AdCategory({
    name: "가상광고",
  });
  static foreign = new AdCategory({
    name: "해외광고",
  });
  static _ = this.closeEnum();

  constructor(props) {
    super();
    Object.defineProperties(this, Object.getOwnPropertyDescriptors(props));
  }
}

export default AdCategory;
